import React from 'react';
import { CheckCircle, Users, Trophy, Target } from 'lucide-react';
import { images } from '../data/mock';

const About = () => {
  const highlights = [
    'Certified ISO Lead Auditors',
     'Certified CMMI Lead Appraisers',
    'Accredited Instructors',
    'CISSP Certified Professionals',
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            {/* Main Image */}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={images.team}
                alt="Professional consulting team"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent" />
            </div>

            {/* Floating Card */}
            <div className="absolute -bottom-8 -right-8 bg-white rounded-2xl shadow-xl p-6 max-w-xs hidden md:block">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center">
                  <Trophy className="w-7 h-7 text-blue-600" />
                </div>
                <div>
                  <div className="text-3xl font-bold text-slate-900">20+</div>
                  <div className="text-slate-600">Years of Excellence</div>
                </div>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-blue-100 rounded-2xl -z-10" />
            <div className="absolute -bottom-4 -left-4 w-32 h-32 border-4 border-green-200 rounded-2xl -z-10" />
          </div>

          {/* Content Side */}
          <div className="space-y-8">
            <div>
              <span className="inline-block text-blue-600 font-semibold text-sm uppercase tracking-wider mb-4">
                About Us
              </span>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
                Leading the Way in{' '}
                <span className="text-green-500">Quality Excellence</span>
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed">
                Advanced Network Technology Solutions (ANTS) is a premier provider of training and implementation services. Our team of industry specialists brings decades of experience, partnering with organizations to secure and sustain certifications across ISO, CMMI, CMMC, and SOC frameworks. Out team includes:
              </p>
            </div>

            {/* Highlights */}
            <div className="space-y-4">
              {highlights.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 p-4 bg-slate-50 rounded-xl hover:bg-blue-50 transition-colors group"
                >
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center group-hover:bg-blue-600 transition-colors">
                    <CheckCircle className="w-5 h-5 text-blue-600 group-hover:text-white transition-colors" />
                  </div>
                  <span className="text-slate-700 font-medium">{item}</span>
                </div>
              ))}
            </div>

            {/* Stats Row */}
            <div className="grid grid-cols-3 gap-6 pt-6 border-t border-slate-200">
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600">150+</div>
                <div className="text-sm text-slate-600">Clients Served</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-green-500">1000+</div>
                <div className="text-sm text-slate-600">Projects Done</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600">98%</div>
                <div className="text-sm text-slate-600">Success Rate</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
